import { Checkbox, FormControlLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const CustomCheckbox = ({ labelText, value, ...props }) => (
  <FormControlLabel control={<Checkbox {...props} checked={value} />} label={labelText} />
);

CustomCheckbox.propTypes = {
  labelText: PropTypes.string,
  name     : PropTypes.string.isRequired,
  onChange : PropTypes.func.isRequired,
  value    : PropTypes.bool.isRequired,
};

CustomCheckbox.defaultProps = {
  labelText: undefined,
};

export default CustomCheckbox;
